var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBasket = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  fill: "none",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#basket_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.9,
  d: "M10.555 20.125 9.789 14h2.297l.766 6.125zM15.915 14l-.767 6.125h2.297L18.211 14zM26.25 9.79v2.296h-1.317l-1.654 9.999a2.664 2.664 0 0 1-2.633 2.25H7.354a2.664 2.664 0 0 1-2.633-2.25l-1.654-10H1.75V9.79h6.783l1.823-4.976h2.434l-1.852 4.976h6.124L15.21 4.813h2.434l1.823 4.976zm-3.644 2.296H5.394l1.532 9.632a.38.38 0 0 0 .367.321h13.291a.38.38 0 0 0 .368-.322z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "basket_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M1.75 1.75h24.5v24.5H1.75z"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBasket);
export default ForwardRef;